<template>
  <div class="message-system-message">{{ props.dataItem.time }}&nbsp;&nbsp;{{ text }}</div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  dataItem: {
    type: Object,
    default: () => ({
      content: ''
    })
  },
  message: {
    type: Object,
    default: () => ({
      content: ''
    })
  }
})

const text = computed(() => props.message.content || '')
</script>

<style lang="scss" scoped>
.message-system-message {
  padding: 0 48px;
  font-size: 12px;
  line-height: 16px;
  color: #9e9e9e;
  text-align: center;
  word-break: break-all;
}
</style>
